
import pro1 from "../assets/Project 1.jpg"
import pro2 from "../assets/Project 2.jpg"
import pro3 from "../assets/Project 3.jpg"

const ProjectCardData = [
    {
        imgsrc: pro1,
        title:"E-commerce Website Design",
        text:"An E-Commerce website is an online store where you can buy or sell products online.",
        view:"https://onlinepasalnepal.netlify.app",
    },
    {
        imgsrc: pro2,
        title:"Alumni Management System",
        text:"Alumni Management System is a targeted and dedicated platform that provides 100% data security.0 It has been designed using React Node.js with user-friendly form controls to make it an interactive application. It stores an Alumni database which makes it easier to maintain records such as alumni details, course details,",
        view:"",
    },
    {
        imgsrc: pro3,
        title:"Portfolio Management",
        text:"Professional licensed portfolio managers work on behalf of clients, while individuals may choose to build and manage their own portfolios",
        view:"",
    }
]

export default ProjectCardData